import React, { useEffect, useRef, useState } from 'react';
import {useNavigate, useParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import $ from 'jquery';
import 'datatables.net';
import SubscriptionService from '../../services/SubscriptionService';


function AddSubscription({ ClientId, props }) {
 // const { id } = useParams(); 
  const [form, setForm] = useState({
    subscriptionPlanId:"",
    price:"",
    startDate:"",
    endDate:"",
    clientId: ClientId
  });

  const [formError, setFormError] = useState({});
  const [Subscriptions, setSubscriptions] = useState([]);
  const navigate = useNavigate();
  const toast = useRef(null);
  const [SubscriptionPlans, setSubscriptionPlans] = useState([]);
  const [loadingSubscriptionPlans, setLoadingSubscriptionPlans] = useState(true);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value,  });
  setFormError((prevErrors) => ({ ...prevErrors, [name]: '' })); 
  };
  
  async function saveSubscription() {
    const errors = {};
    Object.keys(form).forEach(key => {
      if (!form[key].trim()) {
        errors[key] = `Please enter ${key}`;
      }
    });

    setFormError(errors); 
    if (Object.keys(errors).length > 0) {
      console.error('Validation errors:', errors);
      return;
    }
    const requestData = {
      subscriptionPlanId: form.subscriptionPlanId,
      price: form.price,
      startDate: form.startDate,
      endDate: form.endDate,
      isActive: true,
      clientId: ClientId
    };
    try {
       {
        await SubscriptionService.createSubscription(requestData);
        toast.current.show({ severity: 'success', summary: 'Success', detail: ' Subscription added successfully' });
        await this.fetchSubscriptions();
        this.props.setActiveTab('subscription'); 
    }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const validationErrors = error.response.data.errors;
        setFormError(validationErrors);
      } else {
        console.log("Error saving Subscription:", error);
      }
    }
  }

  const validateForm = () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 

    Object.keys(form).forEach((key) => {
      if (!form[key]?.trim()) {
        errors[key] = `Please enter ${key}`;
      }
    });
    
    if (form.email && !emailRegex.test(form.email)) {
      errors.email = "Please enter a valid email address";
    }

    setFormError(errors);
    return Object.keys(errors).length === 0;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
        saveSubscription();
        resetForm();
    }
  };

  function resetForm() {
    setForm({
        subscriptionPlanId:"",
        price:"",
        startDate:"",
        endDate:"",
        clientId: ""
    });
    setFormError({});
  }


  useEffect(() => {    
    const fetchSubscriptions = async () => {
      try {
        debugger
        const subscriptions = await SubscriptionService.getSubscriptionsByClientId(ClientId);
        setSubscriptions(subscriptions);
      } catch (error) {
        console.error('Error fetching Users: ', error);  
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch subscriptions data' });
      }
    };
    fetchSubscriptions();
    setTimeout(() => {
      $('#tableData').DataTable();
    }, 0);
  }, [ClientId, saveSubscription]);

  useEffect(() => {
    const fetchSubscriptionPlans = async () => {
      try {
        const subscriptionplans = await SubscriptionService.getAllSubscriptionPlans();
        setSubscriptionPlans(subscriptionplans);
      } catch (error) {
        console.error("Error fetching subscriptionplans:", error);
      } finally {
        setLoadingSubscriptionPlans(false);
      }
    };
    fetchSubscriptionPlans();
  }, []);

  function renderSubscriptions() {
    return Subscriptions.map((subscription) => {
    return (
      <tr key={subscription.id}>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{subscription.subscriptionPlan ? subscription.subscriptionPlan.subscriptionPlanName : ''}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{subscription.price}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{new Date(subscription.startDate).toLocaleDateString()}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{new Date(subscription.endDate).toLocaleDateString()}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{subscription.isActive ? 'Active' : 'Inactive'}</span>
        </td>
        <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold"><button
            className="btn btn-outline-dark btn-sm"
            onClick={() => navigate(`/editsubscription/${subscription.id}`)}
          >
            <i className="pi pi-pencil" style={{ fontSize: '1.5rem' }}></i>
          </button>
          <button
            className="btn btn-outline-light btn-sm"
            onClick={() => deleteSubscription(subscription.id)} style={{ marginLeft: '10px',paddingRight:'10px' }}
          >
            <i className="pi pi-trash" style={{ fontSize: '1.5rem', color: 'red' }}></i>
          </button>
          </span>
        </td>
      </tr>
    );
  });
}


const deleteSubscription = async (subscriptionId) => {
    try {
      await SubscriptionService.deleteSubscription(subscriptionId);
      toast.current.show({ severity: 'success', summary: 'Success', detail: 'Subscription deleted successfully', life: 3000 });
      setSubscriptions(Subscriptions.filter(subscription => subscription.id !== subscriptionId));
    } catch (e) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to delete Subscription', life: 3000 });
      console.log(e);
    }
  };

  return (
    <div>
        <Toast ref={toast} />
        <form onSubmit={onSubmit}> 
        <div className="row m-2 p-2">
            <div className="card text-center mx-auto">
                <div className="card-body text-start text-dark">
                <div className="form-group row">
          <div className="form-group row">
          <label className="col-lg-2" htmlFor="subscriptionPlanId">
       Subscription Plan
            </label>
            <div className="col-lg-4">
                <select
          name="subscriptionPlanId"
          id="subscriptionPlanId"
          className="form-control"
          value={form.subscriptionPlanId}
          onChange={changeHandler}
        >
          <option value=""> Select</option>
          {loadingSubscriptionPlans ? (
            <option>Loading...</option>
          ) : (
            SubscriptionPlans.map((subscriptionPlan) => (
              <option key={subscriptionPlan.id} value={subscriptionPlan.id}>
                {subscriptionPlan.subscriptionPlanName}
              </option>
            ))
          )}
        </select>
                </div>
          <label className="col-lg-2" htmlFor="price">
       Price
            </label>
            <div className="col-lg-3">
          <input
            type="number"
            name="price"
            id="price"
            className="form-control"
            value={form.price}
            onChange={changeHandler} 
          />
          <p className="text-danger">{formError.price}</p>
          </div>
        </div>

        <div className="form-group row">
          <label className="col-lg-2" htmlFor="startDate">
        Start Date
            </label>
            <div className="col-lg-4">
          <input
            type="datetime-local"
            name="startDate"
            id="startDate"
            className="form-control"
            value={form.startDate}
            onChange={changeHandler} 
          />
          <p className="text-danger">{formError.startDate}</p>
          </div>
          <label className="col-lg-2" htmlFor="endDate">
        End Date
            </label>
            <div className="col-lg-3">
          <input
            type="datetime-local"
            name="endDate"
            id="endDate"
            className="form-control"
            value={form.endDate}
            onChange={changeHandler} 
          />
          <p className="text-danger">{formError.endDate}</p>
          </div>
        </div>
        </div>
                </div>
                <div className="card-footer text-muted bg-light">
                  <button type="submit"  className="btn btn-save btn-dark text-white"> <i className="pi pi-plus"></i>Submit</button>
                </div>
            </div>
        </div>

        </form>
        <br></br>
      <div class="col-12">
          <div class="card my-4">
            <div class="card-body px-0 pb-2">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0" id="tableData">
                  <thead>
                    <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Subscription Plan</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Price</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Start Date</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">End Date</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Status</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Action</th> 
                    </tr>
                  </thead>
                  <tbody>
                  {renderSubscriptions()}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
}

export default AddSubscription;
